import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type Severity = 'success' | 'info' | 'warning' | 'error';

interface SnackState {
    snack: { message?: string; severity?: Severity };
    open: boolean;
}

const initialState: SnackState = {
    snack: {},
    open: false,
};

const snackSlice = createSlice({
    name: 'snack',
    initialState,
    reducers: {
        setSnack(state, action: PayloadAction<{ message: string; severity: Severity }>) {
            state.snack = action.payload;
            state.open = true;
        },
        removeSnack(state) {
            state.snack = {};
            state.open = false;
        },
    },
});

export const { setSnack, removeSnack } = snackSlice.actions;

// Convenience action creator matching the legacy `setSnackAction(message, severity)` shape
// so existing call sites stay readable.
export const setSnackAction = (message: string, severity: Severity) =>
    setSnack({ message, severity });

export default snackSlice.reducer;
